<template>
  <client-only>
    <div :class="bindClass" :style="bindFootersColor">
      <!-- H5 -->
      <div :class="customMobileClass" v-if="renderMobile">
        <p class="privacy-policy">
          <span
            ><a @click="goDetail('terms')">{{ $t('common.terms') }}</a></span
          >
          <span class="line">|</span>
          <span
            ><a @click="goDetail('privacy')">{{
              $t('common.privacy_policy')
            }}</a></span
          >
          <template v-if="page === 'home'">
            <span class="line">|</span>
            <span
              ><a @click="goDetail('contact')">{{
                $t('common.contact_us')
              }}</a></span
            >
          </template>
        </p>
        <PublicFooterCookie :theme="theme" />
        <p class="copyright">
          Copyright &copy; 2010-{{ getCurYear }} Toplupe. All Rights Reserved
        </p>
      </div>
      <!-- PC -->
      <div
        v-else-if="renderDesktop"
        class="desktop-footer"
        :style="bindTextColor"
      >
        <div class="footer-top">
          <div class="footer-website" @click="clickHander('website')">
            <h3>{{ websiteInfo.title }}</h3>
            <img
              :class="!websiteInfo.website ? 'no_url' : ''"
              v-lazy="websiteInfo.logo"
            />
          </div>
          <div class="footer-share">
            <h3>{{ websiteInfo.shareText }}</h3>
            <DesktopShare ref="desktopShare" @toShare="toShare" />
            <div class="footer-bom">
              <div class="detail-footer">
                <p class="contact" @click="clickHander('terms')">
                  {{ $t('common.terms') }}
                </p>
                <span class="line">|</span>
                <p class="contact" @click="clickHander('privacy')">
                  {{ $t('common.privacy_policy') }}
                </p>
                <span class="line">|</span>
                <p class="contact" @click="clickHander('contact')">
                  {{ $t('common.contact_us') }}
                </p>
              </div>
              <div class="copyright-pc">
                Copyright &copy; 2010-{{ getCurYear }} Toplupe. All Rights
                Reserved
              </div>
            </div>
          </div>
          <div class="footer-down">
            <!-- <h3>Download APP</h3> -->
            <!-- <img v-lazy="require(`@/assets/images/common/qrcode.png`)" /> -->
          </div>
        </div>
      </div>
    </div>
  </client-only>
</template>

<script>
  import PublicFooterCookie from '@/components/PublicFooterCookie'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { feedbackClick } from '@/pages/firebase'
  import { mapState } from 'vuex'
  import { DesktopShare } from '@/components/PublicShare/index.js'
  import { shareClick } from '@/pages/firebase'
  import { jumpToPage } from '@/utils/utils'

  export default {
    name: 'public-footer',
    mixins: [styleConfiguration],
    props: {
      page: {
        type: String,
        default: 'details',
      },
      theme: {
        type: String,
        default: '',
      },
    },
    components: {
      PublicFooterCookie,
      DesktopShare,
    },
    computed: {
      ...mapState([
        'gameName',
        'isApp',
        'isMobile',
        'isDesktop',
        'region',
        'layoutVersion',
      ]),

      customMobileClass() {
        const _page = this.page !== 'home' ? 'default-policy' : ''
        return ['site-policy', this.theme, _page]
      },

      bindClass() {
        const defaultClass = ['public-footer-content', this.layoutVersion]
        const resClass = this.isDesktop
          ? `${defaultClass[0]}-desktop`
          : `${defaultClass[0]}-mobile`

        const isHomePage =
          this.page === 'home' ? `${defaultClass[0]}-home` : `${this.gameName}`

        return defaultClass.concat(resClass, isHomePage)
      },

      renderMobile() {
        const isDetails = this.$route.name === 'Detail2'
        if (this.isApp && isDetails) return false
        if (this.isMobile) return true
        if (this.isDesktop && this.page === 'home') return true
        return false
      },
      renderDesktop() {
        return this.isDesktop && this.page === 'details'
      },

      getCurYear() {
        return new Date().getFullYear()
      },

      websiteInfo() {
        return {
          website: '',
          logo: this.gameIcon,
          title: 'Official website',
          shareText: 'Share to',
        }
      },
      bindFootersColor() {
        if (this.isDesktop) {
          return this.pMouldBckColor.backgroundColor
            ? this.pMouldBckColor
            : this.payBgColor
        }
        return null
      },
      bindTextColor() {
        if (this.isDesktop) {
          return this.pcTextColor.color ? this.pcTextColor : this.mFontColor
        }
        return null
      },
    },
    mounted() {},
    methods: {
      toShare(item) {
        const { id } = item || {}
        shareClick({ page: this.gameName, share_name: id })
      },
      goDetail(type) {
        const { page } = this
        if (type === 'contact') {
          feedbackClick({ page })
        }
        const { query } = this.$route
        this.$router_push({
          path: `/${type}`,
          query: {
            ...query,
            type: 'contact_us',
            from: page,
          },
        })
      },
      clickHander(type) {
        const gameName = this.gameName.toLocaleLowerCase()
        if (type === 'website') {
          // 没有网址走CMS配置网址、
          if (this.websiteInfo.website === '') {
            if (this.pcBtmUrl !== '') {
              jumpToPage(this.pcBtmUrl, 'open')
            }
          }
        } else if (type === 'contact') {
          feedbackClick({ page: gameName })
          this.$router_push({
            path: '/feedback-edit',
            query: {
              ...this.$route.query,
              type: 'contact_us',
              from: 'game-detail',
            },
          })
        } else {
          const { query } = this.$route
          this.$router_push({
            path: `/${type}`,
            query: {
              ...query,
              type: 'contact_us',
              from: gameName,
            },
          })
        }
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
  @media (min-width: 768px) and (max-width: 1280px) {
    @import './index_pc.scss';
  }
  @media (max-width: 1100px) {
    @import './1100.scss';
  }
</style>
